module.exports = __webpack_public_path__ + "img/yw2En.07112342.jpg";